import { render, staticRenderFns } from "./ThePreloader.vue?vue&type=template&id=000fceef&"
import script from "./ThePreloader.vue?vue&type=script&lang=js&"
export * from "./ThePreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports